import React from 'react';
import clsx from 'clsx';
import { Tooltip } from '@nextiva/next-ui-components';
import styles from './NotPermittedAction.scss';

const defaultText = 'You have no permission to perform this action';

export const NotPermittedAction = ({
  children,
  className,
  message = defaultText,
  displayBlock,
  placement = 'top',
}) => (
  <div
    className={clsx(
      className,
      styles.actionWrapper,
      displayBlock && styles['actionWrapper--block'],
    )}
  >
    <Tooltip title={message} placement={placement}>
      {children}
    </Tooltip>
  </div>
);
